(function () {
  'use strict';

  var PAGE_COOKIE = 'iuh_survey_page';
  var DEBUG = window.location.search.indexOf('survey_debug=1') !== -1;

  if (document.cookie.indexOf('iuh_survey_session=1') !== -1) {
    document.cookie = 'iuh_survey_session=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.split(';').find(function (c) {
      return c.trim().indexOf(name + '=') === 0;
    });
    return match ? decodeURIComponent(match.split('=')[1]) : null;
  }

  function setSessionCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;SameSite=Lax';
  }

  function pageViews() {
    if (window.IUHPopupOrchestrator) return window.IUHPopupOrchestrator.pageViews();
    return parseInt(getCookie('iuh_page_views') || '0', 10) || 0;
  }

  function minPages() {
    return window.IUHPopupOrchestrator ? window.IUHPopupOrchestrator.minPageViews : 2;
  }

  function exitAllowed() {
    return DEBUG || pageViews() >= minPages();
  }

  function samePageBlocked() {
    if (DEBUG) return false;
    return getCookie(PAGE_COOKIE) === location.pathname;
  }

  function blockThisPage() {
    setSessionCookie(PAGE_COOKIE, location.pathname);
    window.__iuhExitShown = true;
  }

  function shouldBlockExitTrigger() {
    if (DEBUG) return false;
    if (samePageBlocked()) return true;
    if (!exitAllowed()) return true;
    return false;
  }

  document.addEventListener('mouseleave', function (e) {
    if (e.clientY > 10) return;
    if (!shouldBlockExitTrigger()) return;
    e.stopImmediatePropagation();
  }, true);

  window.addEventListener('popstate', function (e) {
    if (!shouldBlockExitTrigger()) return;
    e.stopImmediatePropagation();
  }, true);

  document.addEventListener('mousemove', function (e) {
    if (DEBUG || !window.SurveySystem) return;
    if (e.clientY > 80) return;
    window.SurveySystem.pageLoadTime = Date.now();
  }, { passive: true });

  function watchContainer(id) {
    var node = document.getElementById(id);
    if (!node || node.__iuhSurveyWatch) return;
    node.__iuhSurveyWatch = true;

    new MutationObserver(function () {
      if (node.classList.contains('sv-visible')) blockThisPage();
    }).observe(node, {
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function initWatch() {
    watchContainer('sv-container');
    watchContainer('iuh-survey-widget');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#sv-container .sv-close, #iuh-survey-widget .sv-close')) {
      blockThisPage();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWatch);
  } else {
    initWatch();
  }

  var watchTimer = setInterval(initWatch, 500);
  setTimeout(function () { clearInterval(watchTimer); }, 15000);
})();
